import { Outlet } from "react-router";

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import ErrorBoundary from "~/components/ErrorBoundary";
import queryClient from "~/lib/cache/queryClient";
import AnalyticsProvider from "~/providers/AnalyticsProvider";

/**
 * This file is the root layout for the application.
 * It is used to wrap all pages and provide global
 * styles.
 *
 * @param {Object} props - The component props.
 * @param {ReactNode} props.children - The children to be rendered inside the layout.
 * @return {JSX.Element} The root layout component.
 */
const LayoutRoot = () => {
  return (
    <div className="min-h-full">
      <QueryClientProvider client={queryClient}>
        <AnalyticsProvider>
          <ErrorBoundary boundaryName="ApplicationRoot" fallbackMode="fullpage">
            <Outlet />
          </ErrorBoundary>
          <ReactQueryDevtools initialIsOpen={false} />
        </AnalyticsProvider>
      </QueryClientProvider>
    </div>
  );
};

export default LayoutRoot;
